import { axiosInstance } from "../../utils";

const actions = {
  FETCH_PROFILE_REQUESTED: "FETCH_PROFILE_REQUESTED",
  FETCH_PROFILE_SUCCEEDED: "FETCH_PROFILE_SUCCEEDED",
  FETCH_PROFILE_FAILED: "FETCH_PROFILE_FAILED",

  UPDATE_PROFILE_REQUESTED: "UPDATE_PROFILE_REQUESTED",
  UPDATE_PROFILE_SUCCEEDED: "UPDATE_PROFILE_SUCCEEDED",
  UPDATE_PROFILE_FAILED: "UPDATE_PROFILE_FAILED",

  CLEAR_ALERT_MESSAGE: "CLEAR_ALERT_MESSAGE",

  clearAlertMessage: () => {
    return {
      type: actions.CLEAR_ALERT_MESSAGE,
    };
  },

  fetchCurrentProfile: (params = undefined) => {
    return {
      type: actions.FETCH_PROFILE_REQUESTED,
      payload: params,
    };
  },

  getCurrentProfile: async (params = undefined) => {
    const url = `users/settings`;

    try {
      const profile = await axiosInstance.get(url, { params });
      return profile.data;
    } catch (error) {
      throw error;
    }
  },

  editCurrentProfile: (data = undefined) => {
    return {
      type: actions.UPDATE_PROFILE_REQUESTED,
      payload: data,
    };
  },

  updateCurrentProfile: async (data = undefined) => {
    const url = `users/settings`;

    let bodyFormData = new FormData();
    if (data.username && data?.usernameChanged === true)
      bodyFormData.set("username", data.username);
    if (data.full_name) bodyFormData.set("full_name", data.full_name);
    if (data.email) bodyFormData.set("email", data.email);
    if (data.password) bodyFormData.set("password", data.password);
    if (data.old_password) bodyFormData.set("old_password", data.old_password);
    if (data.mobile_number && data?.mobileChanged === true)
      bodyFormData.set("mobile_number", data.mobile_number);
    if (data.profile_image) {
      bodyFormData.append("profile_image", data.profile_image);
    }

    if (data?.usernameChanged === false) {
      data = {
        ...data,
        username: undefined,
      };
    }

    try {
      const profile = await axiosInstance.put(url, bodyFormData);
      return profile.data;
    } catch (error) {
      throw error;
    }
  },
};
export default actions;
